export const LeaderboardIDs = {
    GLOBAL: 'Global',
    WEEKLY: 'Weekly',
    CONTEXTUAL: 'Friends'
}

/*------------------ Leaderboard Config -------------------*/
export interface ILeaderboardConfig
{
    id: string;
    key: string;
    friends?: boolean;
    contextual?: boolean;
}

export const Leaderboards: { [key: string]: ILeaderboardConfig } = {
    GLOBAL: {
        id: LeaderboardIDs.GLOBAL,
        key: 'Global'
    },
    GLOBAL_FRIENDS: {
        id: LeaderboardIDs.GLOBAL,
        key: 'GlobalFriends',
        friends: true,
    },
    WEEKLY: {
        id: LeaderboardIDs.WEEKLY,
        key: 'Weekly'
    },
    CONTEXTUAL: {
        id: LeaderboardIDs.CONTEXTUAL,
        key: 'Contextual',
        contextual: true
    }
}